import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceAffiliateReportByDate.graphql';
import { Query, QuerymarketplaceAffiliateReportByDateArgs } from '../../__generated__/globalTypes';

export const useMarketplaceAffiliateReportByDateQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceAffiliateReportByDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceAffiliateReportByDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceAffiliateReportByDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceAffiliateReportByDateArgs>
): QueryResult<Query, QuerymarketplaceAffiliateReportByDateArgs> & {
  getMarketplaceAffiliateReportByDate: LazyQueryExecFunction<Query, QuerymarketplaceAffiliateReportByDateArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceAffiliateReportByDate, result] = useLazyQuery<Query, QuerymarketplaceAffiliateReportByDateArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getMarketplaceAffiliateReportByDate, ...result };
};

export const useMarketplaceAffiliateReportByDatePromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceAffiliateReportByDate = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceAffiliateReportByDateArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceAffiliateReportByDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceAffiliateReportByDate };
};
// Suspense Query Hooks
export const useMarketplaceAffiliateReportByDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceAffiliateReportByDateArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceAffiliateReportByDateArgs>(QUERY, {
    ...options
  });

  return result;
};
